import { IScope } from 'angular'
import ngRedux from 'ng-redux'
import { EditCustomerModalProps } from '@vend/business-components'
import { ApiCustomer } from '@vend/types'
import { getDisplayNameFromGqlCustomer } from '@vend/react-utilities'
import { $rootScope } from '../../../../ng-compat/imports'
import { EVENT } from '../../../../constants/wr-events'
import { CustomerManager } from '../../../../managers/customer-manager'
import {
  ReactModalController,
  ReactModalResult,
} from '../../ReactModalController'
import { wrToastSuccess } from '../../helios/ToastNotifications/WrToastNotifications'
import { attachCustomerToSale } from '../../../../state/slices/currentSale/currentSaleSlice'
import {
  createApiCustomer,
  isApiCustomer,
} from '../../../../util/api-customer-utils'

interface Options {
  customer: {
    id?: string
    firstName?: string
    lastName?: string
    contact?: {
      email: string | null
      mobile: string | null
      fax: string | null
      phone: string | null
    }
  }
}

export interface EditCustomerModalResult extends ReactModalResult {
  action?: string
  customer: ApiCustomer
}

/**
 * Controller class for the customer edit modal
 *
 * @class CustomerModalController
 */
export class EditCustomerModalController extends ReactModalController {
  public options: EditCustomerModalProps

  constructor(
    $scope: IScope,
    close: (val: Promise<any>) => void,
    vdEscapeStack: any,
    private readonly customerManager: CustomerManager,
    private readonly $ngRedux: ngRedux.INgRedux,
    options: Options
  ) {
    'ngInject'
    super($scope, close, vdEscapeStack)

    this.options = {
      customer: options.customer,
      onClose: this.dismiss,
      onSave: async (newCustomer, originalCustomer) => {
        const updatedCustomer = await this.customerManager.refreshCustomer({
          id: newCustomer.id,
        })

        this.$ngRedux.dispatch(
          attachCustomerToSale(
            isApiCustomer(updatedCustomer)
              ? updatedCustomer
              : createApiCustomer(updatedCustomer)
          )
        )
        $rootScope.$emit(EVENT.SALE_CUSTOMER_UPDATED)

        const action = originalCustomer?.id ? 'updated' : 'created'
        this.close(Promise.resolve({ action, customer: updatedCustomer }))

        const customerName = getDisplayNameFromGqlCustomer(newCustomer)
        const toastMsgKey = originalCustomer?.id
          ? 'customer.update.success'
          : 'customer.create.success'

        wrToastSuccess(toastMsgKey, { customerName })
      },
      onSelectExistingCustomer: async customer => {
        const updatedCustomer = await this.customerManager.refreshCustomer({
          id: customer.id,
        })
        this.close(
          Promise.resolve({ action: 'updated', customer: updatedCustomer })
        )
      },
    }
  }
}
